import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalog } from "../redux/slices/catalogSlice";
import { generateSitemap } from "../utils/utils/generateSitemap";


const Sitemap = () => {
  const products = useSelector(state => state.catalog.underCatalog); 
  const [sitemap, setSitemap] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCatalog()); // Загружаем данные каталога
  }, [dispatch]);

  useEffect(() => {
    if (products && products.length > 0) { // Запускаем генерацию, когда данные появились
      
      const newSitemap = generateSitemap(products); // Генерируем sitemap
      setSitemap(newSitemap);
      console.log(newSitemap);
      
      setSitemap(generateSitemap(products));
    }
  }, [products]);

  if (products.length === 0) return <p>⏳ Загрузка каталога...</p>; // Ожидание загрузки данных

  return <textarea value={sitemap} readOnly rows={20} cols={80} />;
};

export default Sitemap;